// RecipientModal.js
import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { connect } from "react-redux";
import actions from "../../../store/notificatiommodule/action";
import Service from "./NotificationService";
import { toast } from "react-toastify";
import PermissionFeature from "../../Permissions/PermissionFeature";
import AuthService from "../../Auth/AuthService";
import _ from "lodash";
class RecipientModal extends React.Component {
  state = {
    recipients: [],
    assignedRecipients: [],
    activeTab: 1,
    selectedTeam: null,
    section1Teams: [],
    section2Positions: [],
    section3Items: [],
    expandedTeamsInSection3: [],
    searchTerm: "",
    loading: false,
    saving: false,
    fetchingRecipients: false, // New state for fetching recipients
  };

  componentDidMount() {
    this.loadTeamsAndPositions();
  }

  componentDidUpdate(prevProps, prevState) {
    // Reload when modal becomes visible with new props
    if (this.props.show && !prevProps.show) {
      this.loadTeamsAndPositions(_.isEmpty(this.state.recipients));
    }

    // When trigger changes, fetch its recipients
    if (
      this.props.trigger !== prevProps.trigger &&
      this.props.show &&
      this.props.trigger
    ) {
      this.fetchTriggerRecipients();
    }

    // When recipients prop changes (for backward compatibility)
    if (
      this.props.recipients !== prevProps.recipients &&
      this.props.show &&
      !this.props.trigger
    ) {
      this.loadExistingRecipients();
      this.filterTeamsByTab();
    }

    if (prevState.activeTab !== this.state.activeTab) {
      this.filterTeamsByTab();
    }

    if (prevState.recipients !== this.state.recipients) {
      this.filterTeamsByTab();
    }

    if (prevState.searchTerm !== this.state.searchTerm) {
      this.filterTeamsByTab();
    }

    // Reset when modal closes
    if (prevProps.show && !this.props.show) {
      this.resetModalState();
    }
  }

  resetModalState = () => {
    this.setState({
      activeTab: 1,
      selectedTeam: null,
      section2Positions: [],
      expandedTeamsInSection3: [],
      searchTerm: "",
      saving: false,
      section3Items: [],
    });
  };

  // NEW: Fetch recipients for the current trigger from API
  fetchTriggerRecipients = async () => {
    const { trigger } = this.props;

    if (!trigger || !trigger.id) {
      return;
    }

    this.setState({ fetchingRecipients: true });

    try {
      const data = await Service.GetRecipientsByTriggerId(trigger.id);

      if (data != null) {
        // Convert API response to modal's expected format
        const section3Items = [];

        data.forEach((recipient) => {
          if (recipient.recipient_Type_Id === 1) {
            // It's a team
            const team = this.findTeamById(recipient.recipient_Id);
            if (team) {
              section3Items.push({
                id: recipient.id || Date.now() + Math.random(),
                recipientId: team.id,
                recipientType: 1,
                name: team.teamName,
                type: "team",
                teamId: team.id,
                teamName: team.teamName,
                isLinkedPosition: false,
                positions: team.positions,
                scope: team.teamScope,
              });
            } else {
              // Team not found in recipients list (might be from other scope)
              section3Items.push({
                id: recipient.id || Date.now() + Math.random(),
                recipientId: recipient.recipient_Id,
                recipientType: 1,
                name: recipient.recipient_Name,
                type: "team",
                teamId: recipient.recipient_Id,
                teamName: recipient.recipient_Name,
                isLinkedPosition: false,
                positions: [],
              });
            }
          } else if (
            recipient.recipient_Type_Id === 2 ||
            recipient.recipient_Type_Id === 3
          ) {
            // It's a position or linked position
            const position = this.findPositionById(recipient.recipient_Id);
            if (position) {
              const team = this.findTeamByPositionId(position.id);
              if (team) {
                section3Items.push({
                  id: recipient.id || Date.now() + Math.random(),
                  recipientId: position.id,
                  recipientType: recipient.recipient_Type_Id,
                  name: position.positionName,
                  type: "position",
                  teamId: team.id,
                  teamName: team.teamName,
                  scope: position.teamPositionScope,
                  isLinkedPosition: position.isLinkedPosition || false,
                });
              }
            } else {
              // Position not found in recipients list
              section3Items.push({
                id: recipient.id || Date.now() + Math.random(),
                recipientId: recipient.recipient_Id,
                recipientType: recipient.recipient_Type_Id,
                name: recipient.recipient_Name,
                type: "position",
                teamId: null,
                teamName: "Unknown Team",
                isLinkedPosition: recipient.recipient_Type_Id === 3,
              });
            }
          }
        });

        this.setState({ section3Items });
      } else {
        this.setState({ section3Items: [] });
      }
    } catch (error) {
      console.error("Error fetching trigger recipients:", error);
      // Fallback to props recipients if API fails
      this.loadExistingRecipients();
    } finally {
      this.setState({ fetchingRecipients: false });
      this.filterTeamsByTab();
    }
  };

  async loadTeamsAndPositions(loading = true) {
    this.setState({ loading: loading });
    let data = await Service.GetRecipients();
    await this.setState({
      recipients: data || [],
      loading: false,
    });

    // After loading teams, fetch trigger recipients if trigger exists
    if (this.props.trigger && this.props.trigger.id) {
      await this.fetchTriggerRecipients();
    } else {
      this.loadExistingRecipients();
    }

    this.filterTeamsByTab();
  }

  loadExistingRecipients = () => {
    const { recipients: existingRecipients } = this.props;

    if (!existingRecipients || existingRecipients.length === 0) {
      this.setState({ section3Items: [] });
      return;
    }

    const section3Items = [];

    existingRecipients.forEach((recipient) => {
      if (recipient.recipient_Type_Id === 1) {
        const team = this.findTeamById(recipient.recipient_Id);
        if (team) {
          section3Items.push({
            id: recipient.id || Date.now() + Math.random(),
            recipientId: team.id,
            recipientType: 1,
            name: team.teamName,
            type: "team",
            teamId: team.id,
            teamName: team.teamName,
            isLinkedPosition: false,
            scope: team.teamScope,
            positions: team.positions,
          });
        }
      } else if (
        recipient.recipient_Type_Id === 2 ||
        recipient.recipient_Type_Id === 3
      ) {
        const position = this.findPositionById(recipient.recipient_Id);
        if (position) {
          const team = this.findTeamByPositionId(position.id);
          if (team) {
            section3Items.push({
              id: recipient.id || Date.now() + Math.random(),
              recipientId: position.id,
              recipientType: recipient.recipient_Type_Id,
              name: position.positionName,
              type: "position",
              teamId: team.id,
              teamName: team.teamName,
              scope: position.teamPositionScope,
              isLinkedPosition: position.isLinkedPosition || false,
            });
          }
        }
      }
    });

    this.setState({ section3Items });
  };

  findTeamById = (teamId) => {
    const { recipients } = this.state;
    return recipients.find((team) => team.id === teamId);
  };

  findPositionById = (positionId) => {
    const { recipients } = this.state;
    for (const team of recipients) {
      const position = team.positions.find((p) => p.id === positionId);
      if (position) return position;
    }
    return null;
  };

  findTeamByPositionId = (positionId) => {
    const { recipients } = this.state;
    return recipients.find((team) =>
      team.positions.some((p) => p.id === positionId)
    );
  };

  filterTeamsByTab = () => {
    const { recipients, activeTab, section3Items, searchTerm } = this.state;

    let filteredTeams = recipients.filter((team) => {
      if (team.scopeType === 1) {
        return activeTab === 1;
      }

      return (
        team.teamScope &&
        team.teamScope.teamScopeObj &&
        team.teamScope.teamScopeObj.some(
          (scope) => scope.scopeType === activeTab
        )
      );
    });

    if (searchTerm) {
      filteredTeams = filteredTeams.filter((team) =>
        team.teamName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    const selectedTeamIds = section3Items
      .filter((item) => item.recipientType === 1)
      .map((item) => item.recipientId);

    filteredTeams = filteredTeams.filter(
      (team) => !selectedTeamIds.includes(team.id)
    );

    this.setState({
      section1Teams: filteredTeams,
      selectedTeam: null,
      section2Positions: [],
    });
  };

  handleTeamClick = (team, filterPosition = false) => {
    const selectedPositionIds = this.state.section3Items
      .filter((item) => item.recipientType === 2 || item.recipientType === 3)
      .map((item) => item.recipientId);

    let availablePositions = team.positions.filter(
      (position) => !selectedPositionIds.includes(position.id)
    );

    if (this.state.searchTerm && filterPosition) {
      availablePositions = availablePositions.filter((position) =>
        position.positionName
          .toLowerCase()
          .includes(this.state.searchTerm.toLowerCase())
      );
    }

    this.setState({
      selectedTeam: team,
      section2Positions: availablePositions,
    });
  };

  handleSelectTeam = (team) => {
    const { section1Teams, section3Items } = this.state;

    const hasSelectedPositions = section3Items.some(
      (item) =>
        (item.recipientType === 2 || item.recipientType === 3) &&
        item.teamId === team.id
    );

    if (hasSelectedPositions) {
      toast.warning(
        `Cannot select team "${team.teamName}" because one or more positions from this team are already selected.`
      );
      return;
    }

    const updatedSection1Teams = section1Teams.filter((t) => t.id !== team.id);

    const teamItem = {
      id: Date.now(),
      recipientId: team.id,
      recipientType: 1,
      name: team.teamName,
      type: "team",
      teamId: team.id,
      teamName: team.teamName,
      scope: team.teamScope,
      isLinkedPosition: false,
      positions: team.positions,
    };

    this.setState({
      section1Teams: updatedSection1Teams,
      section3Items: [...section3Items, teamItem],
      selectedTeam: null,
      section2Positions: [],
    });
  };

  handleSelectPosition = (position) => {
    const { selectedTeam, section2Positions, section3Items } = this.state;

    if (!selectedTeam) return;

    const isTeamSelected = section3Items.some(
      (item) => item.recipientType === 1 && item.recipientId === selectedTeam.id
    );

    if (isTeamSelected) {
      toast.warning(
        `Cannot select position "${position.positionName}" because the team "${selectedTeam.teamName}" is already selected.`
      );
      return;
    }

    const updatedSection2Positions = section2Positions.filter(
      (p) => p.id !== position.id
    );
    const recipientType = position.isLinkedPosition ? 3 : 2;

    const positionItem = {
      id: Date.now(),
      recipientId: position.id,
      recipientType: recipientType,
      name: position.positionName,
      type: "position",
      teamId: selectedTeam.id,
      teamName: selectedTeam.teamName,
      scope: position.teamPositionScope,
      isLinkedPosition: position.isLinkedPosition,
    };

    this.setState({
      section2Positions: updatedSection2Positions,
      section3Items: [...section3Items, positionItem],
    });
  };

  handleRemoveFromSection3 = (item) => {
    const { section3Items, recipients, selectedTeam } = this.state;

    const updatedSection3Items = section3Items.filter((i) => i.id !== item.id);

    this.setState({ section3Items: updatedSection3Items }, () => {
      if (item.recipientType === 1) {
        this.filterTeamsByTab();
      }

      if (
        (item.recipientType === 2 || item.recipientType === 3) &&
        selectedTeam &&
        selectedTeam.id === item.teamId
      ) {
        const team = recipients.find((t) => t.id === item.teamId);
        if (team) {
          const selectedPositionIds = updatedSection3Items
            .filter((i) => i.recipientType === 2 || i.recipientType === 3)
            .map((i) => i.recipientId);

          let availablePositions = team.positions.filter(
            (p) => !selectedPositionIds.includes(p.id)
          );

          // if (this.state.searchTerm) {
          //     availablePositions = availablePositions.filter(position =>
          //         position.positionName.toLowerCase().includes(this.state.searchTerm.toLowerCase())
          //     );
          // }

          this.setState({ section2Positions: availablePositions });
        }
      }
    });
  };

  handleToggleTeamExpand = (itemId) => {
    const { expandedTeamsInSection3 } = this.state;

    if (expandedTeamsInSection3.includes(itemId)) {
      this.setState({
        expandedTeamsInSection3: expandedTeamsInSection3.filter(
          (id) => id !== itemId
        ),
      });
    } else {
      this.setState({
        expandedTeamsInSection3: [...expandedTeamsInSection3, itemId],
      });
    }
  };

  handleSave = async () => {
    const { trigger, fetchNotifications } = this.props;
    const { section3Items } = this.state;

    const saveData = {
      TriggerID: trigger.id,
      Recipients: section3Items.map((item) => ({
        Id: item.recipientId,
        RecipientType: item.recipientType,
      })),
    };

    await this.setState({ saving: true });

    try {
      // Call API to save
      if (await Service.CreatOrUpdateRecipients(saveData)) {
        // Call fetchNotifications from Redux to reload all data
        if (fetchNotifications) {
          await fetchNotifications(true);
        }

        // Close modal
        this.props.onHide();
      }
    } catch (error) {
      console.error("Error saving recipients:", error);
      toast.error("Failed to save recipients. Please try again.");
    } finally {
      await this.setState({ saving: false });
    }
  };

  getRecipientTypeName = (type) => {
    switch (type) {
      case 1:
        return "Team";
      case 2:
        return "Position";
      case 3:
        return "Linked Position";
      default:
        return "";
    }
  };

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value }, () => {
      this.filterTeamsByTab();
      if (this.state.selectedTeam) {
        this.handleTeamClick(this.state.selectedTeam, true);
      }
    });
  };

  renderTeamsSection = () => {
    const { section1Teams, activeTab, selectedTeam } = this.state;

    let tabTitle = "";
    switch (activeTab) {
      case 1:
        tabTitle = "National Teams";
        break;
      case 2:
        tabTitle = "Region Teams";
        break;
      case 3:
        tabTitle = "Facility Teams";
        break;
      default:
        tabTitle = "Teams";
    }

    return (
      <div className="teams-section">
        <h5>{tabTitle}</h5>
        <div className="instruction-text">
          Click on team name to view positions, Click → to select team
        </div>
        <div className="items-list">
          {section1Teams.length === 0 ? (
            <p className="text-muted">No teams available</p>
          ) : (
            section1Teams.map((team) => (
              <div
                key={team.id}
                onClick={() => this.handleTeamClick(team)}
                className={
                  "c-pointer team-row item-row" +
                  (selectedTeam && selectedTeam.id === team.id
                    ? " team-active"
                    : "")
                }
              >
                <span className="item-name">{team.teamName}</span>
                {AuthService.canSPForTeamScope(
                  AuthService.TeamPermissionAction.Add,
                  PermissionFeature.NotificationRecipient,
                  team.teamScope
                ) && (
                  <button
                    className="arrow-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleSelectTeam(team);
                    }}
                    title="Select this team"
                  >
                    → Select
                  </button>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  renderPositionsSection = () => {
    const { selectedTeam, section2Positions } = this.state;

    if (!selectedTeam) {
      return (
        <div className="positions-section">
          <h5>Positions</h5>
          <div className="items-list">
            <p className="text-muted">
              Click on a team name to view its positions
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="positions-section">
        <h5>Positions - {selectedTeam.teamName}</h5>
        <div className="instruction-text">Click → to select position</div>
        <div className="items-list">
          {section2Positions.length === 0 ? (
            <p className="text-muted">No positions available</p>
          ) : (
            section2Positions.map((position) => (
              <div key={position.id} className="item-row">
                <div className="item-info">
                  <span className="item-name">{position.positionName}</span>
                  {position.isLinkedPosition && (
                    <span className="linked-badge">Linked</span>
                  )}
                </div>
                {AuthService.canSPForTeamScope(
                  AuthService.TeamPermissionAction.Add,
                  PermissionFeature.NotificationRecipient,
                  position.teamPositionScope
                ) && (
                  <button
                    className="arrow-btn"
                    onClick={() => this.handleSelectPosition(position)}
                    title="Select this position"
                  >
                    → Select
                  </button>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  renderSelectedSection = () => {
    const {
      section3Items,
      expandedTeamsInSection3,
      recipients,
      searchTerm,
      fetchingRecipients,
    } = this.state;

    if (fetchingRecipients) {
      return (
        <div className="selected-section">
          <h5>Selected Items</h5>
          <div className="text-center py-5">
            <div
              className="spinner-border spinner-border-sm text-primary"
              role="status"
            >
              <span className="sr-only">Loading...</span>
            </div>
            <p className="mt-2 text-muted">Loading recipients...</p>
          </div>
        </div>
      );
    }

    let filteredSection3Items = section3Items;
    if (searchTerm) {
      filteredSection3Items = section3Items.filter(
        (item) =>
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (item.type === "position" &&
            item.teamName.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }

    return (
      <div className="selected-section">
        <h5>Selected Items ({section3Items.length})</h5>
        <div className="items-list">
          {filteredSection3Items.length === 0 ? (
            <p className="text-muted">No items selected</p>
          ) : (
            filteredSection3Items.map((item) => {
              const isExpanded = expandedTeamsInSection3.includes(item.id);
              const teamData =
                item.type === "team"
                  ? item
                  : recipients.find((t) => t.id === item.teamId);

              return (
                <div key={item.id}>
                  <div className="item-row selected-item">
                    <div className="item-info" style={{ flex: 1 }}>
                      {item.type === "team" && (
                        <button
                          className="expand-btn"
                          onClick={() => this.handleToggleTeamExpand(item.id)}
                          title={
                            isExpanded ? "Hide positions" : "Show positions"
                          }
                        >
                          {isExpanded ? (
                            <i class="fas fa-angle-down"></i>
                          ) : (
                            <i class="fas fa-angle-right"></i>
                          )}
                        </button>
                      )}
                      <span
                        className={`item-badge ${
                          item.recipientType === 3 ? "linked-badge" : ""
                        }`}
                      >
                        {this.getRecipientTypeName(item.recipientType)}
                      </span>
                      <span
                        className="item-name"
                        style={{
                          cursor: item.type === "team" ? "pointer" : "default",
                        }}
                        onClick={() => {
                          if (item.type === "team") {
                            this.handleToggleTeamExpand(item.id);
                          }
                        }}
                      >
                        {item.type === "team"
                          ? item.name
                          : `${item.name} (${item.teamName})`}
                      </span>
                    </div>
                    {AuthService.canSPForTeamScope(
                      AuthService.TeamPermissionAction.Delete,
                      PermissionFeature.NotificationRecipient,
                      item.scope
                    ) && (
                      <button
                        className="delete-btn"
                        onClick={() => this.handleRemoveFromSection3(item)}
                        title="Remove item"
                        disabled={this.state.saving}
                      >
                        <span class="text-danger c-pointer" title="Remove item">
                          <i class="fas fa-trash"></i>
                        </span>
                      </button>
                    )}
                  </div>

                  {item.type === "team" &&
                    isExpanded &&
                    teamData &&
                    teamData.positions && (
                      <div className="sub-items-list">
                        {teamData.positions.map((position) => {
                          const isPositionSelected = section3Items.some(
                            (i) =>
                              i.recipientId === position.id &&
                              (i.recipientType === 2 || i.recipientType === 3)
                          );

                          return (
                            <div key={position.id} className="sub-item-row">
                              <div className="item-info">
                                <span className="sub-item-indent">└─</span>
                                <span className="item-name">
                                  {position.positionName}
                                </span>
                                {position.isLinkedPosition && (
                                  <span className="linked-badge">Linked</span>
                                )}
                                {isPositionSelected && (
                                  <span className="selected-badge">
                                    Selected
                                  </span>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                </div>
              );
            })
          )}
        </div>
      </div>
    );
  };

  render() {
    const { show, onHide, trigger } = this.props;
    const {
      activeTab,
      searchTerm,
      loading,
      saving,
      fetchingRecipients,
    } = this.state;

    const isLoading = loading || fetchingRecipients;

    return (
      <Modal
        show={show}
        id="recipientModal"
        onHide={onHide}
        size="xl"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Manage Recipients - {trigger && trigger.trigger_Key}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="global-search">
            <Form.Control
              type="text"
              placeholder="Search teams and positions..."
              value={searchTerm}
              onChange={this.handleSearchChange}
              disabled={saving || fetchingRecipients}
            />
            {searchTerm && (
              <span className="search-results-text">
                Searching in National, Region & Facility
              </span>
            )}
          </div>

          <div className="recipient-tabs">
            <button
              className={`tab-btn ${activeTab === 1 ? "active" : ""}`}
              onClick={() =>
                this.setState({
                  activeTab: 1,
                  selectedTeam: null,
                  section2Positions: [],
                })
              }
              disabled={saving || fetchingRecipients}
            >
              National
            </button>
            <button
              className={`tab-btn ${activeTab === 2 ? "active" : ""}`}
              onClick={() =>
                this.setState({
                  activeTab: 2,
                  selectedTeam: null,
                  section2Positions: [],
                })
              }
              disabled={saving || fetchingRecipients}
            >
              Region
            </button>
            <button
              className={`tab-btn ${activeTab === 3 ? "active" : ""}`}
              onClick={() =>
                this.setState({
                  activeTab: 3,
                  selectedTeam: null,
                  section2Positions: [],
                })
              }
              disabled={saving || fetchingRecipients}
            >
              Facility
            </button>
          </div>

          <div className="recipient-sections">
            <div className="section">
              {isLoading ? (
                <p className="text-muted">Loading...</p>
              ) : (
                this.renderTeamsSection()
              )}
            </div>
            <div className="section">
              {isLoading ? (
                <p className="text-muted">Loading...</p>
              ) : (
                this.renderPositionsSection()
              )}
            </div>
            <div className="section">{this.renderSelectedSection()}</div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onHide}
            disabled={saving || fetchingRecipients}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this.handleSave}
            disabled={saving || fetchingRecipients}
          >
            {saving ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default connect(null, {
  fetchNotifications: actions.fetchNotifications,
})(RecipientModal);
